export default __webpack_public_path__ + "static/media/website.ac466715.svg";